import { CodeHighlight } from '@mantine/code-highlight';

type RawJsonEditorProps = {
  value: string;
  onChange: (value: string) => void;
  errorLine: number | undefined;
  invalid: boolean;
};

/**
 * CodeHighlight is display only, so editing happens in a transparent textarea laid exactly over the
 * highlighted code. Both share font metrics and padding so the caret lines up with the coloured text.
 */
function RawJsonEditor({ value, onChange, errorLine, invalid }: RawJsonEditorProps) {
  const lineCount = value.split('\n').length;
  // Highlighting drops a trailing empty line, which would leave the textarea one line short
  const highlighted = value.endsWith('\n') ? `${value} ` : value;

  return (
    <div className="raw-json-editor" data-invalid={invalid || undefined}>
      <div className="raw-json-editor-gutter" aria-hidden>
        {Array.from({ length: lineCount }, (_, index) => (
          <div key={index} data-error={index + 1 === errorLine || undefined}>
            {index + 1}
          </div>
        ))}
      </div>
      <div className="raw-json-editor-code">
        <CodeHighlight code={highlighted} language="json" withCopyButton={false} radius={0} />
        <textarea
          aria-label="Raw JSON request body"
          aria-invalid={invalid}
          value={value}
          onChange={(event) => onChange(event.currentTarget.value)}
          spellCheck={false}
          autoCapitalize="off"
          autoComplete="off"
          autoCorrect="off"
          wrap="off"
        />
      </div>
    </div>
  );
}

export default RawJsonEditor;
